import React from 'react';
import Modal from './Modal';

interface TermsOfServiceProps {
  isOpen: boolean;
  onClose: () => void;
}

const TermsOfService: React.FC<TermsOfServiceProps> = ({ isOpen, onClose }) => {
  return (
    <Modal isOpen={isOpen} onClose={onClose} title="Terms of Service">
      <div className="terms-content">
        <section className="terms-section">
          <h3>1. Acceptance of Terms</h3>
          <p>
            Welcome to KNOW Bible Trivia ("KNOW," "we," "us," or "our"). By accessing or using our website, mobile application, or any other services provided by KNOW (collectively, the "Services"), you agree to be bound by these Terms of Service. If you do not agree to these terms, please do not use our Services.
          </p>
        </section>
        
        <section className="terms-section">
          <h3>2. Description of Service</h3>
          <p>
            KNOW is an interactive Bible trivia game designed to help users test and expand their knowledge of Scripture in an engaging and educational format. Our Services may include features such as:
          </p>
          <ul>
            <li>Bible-based trivia questions across various categories and difficulty levels</li>
            <li>User profiles and progress tracking</li>
            <li>Leaderboards and achievements</li>
            <li>Saving favorite verses and insights</li>
            <li>Educational resources related to Biblical content</li>
          </ul>
        </section>
        
        <section className="terms-section">
          <h3>3. User Accounts</h3>
          <p>
            To access certain features of our Services, you may be required to create a user account. You are responsible for maintaining the confidentiality of your account credentials and for all activities that occur under your account. You agree to:
          </p>
          <ul>
            <li>Provide accurate and complete information when creating your account</li>
            <li>Update your information as necessary to keep it current</li>
            <li>Notify us immediately of any unauthorized use of your account</li>
            <li>Take responsibility for all activities that occur under your account</li>
          </ul>
        </section>
        
        <section className="terms-section">
          <h3>4. Intellectual Property</h3>
          <p>
            All content included in our Services, including but not limited to text, graphics, logos, button icons, images, audio clips, digital downloads, data compilations, and software, is the property of KNOW, Emraay Solutions, or our content suppliers and is protected by international copyright laws.
          </p>
          <p>
            Scripture quotations are from various Bible translations and are used with permission. All Bible texts and related content are subject to their respective copyright protections.
          </p>
        </section>
        
        <section className="terms-section">
          <h3>5. User Conduct</h3>
          <p>
            When using our Services, you agree not to:
          </p>
          <ul>
            <li>Use our Services for any illegal purpose</li>
            <li>Attempt to gain unauthorized access to any portion of our Services</li>
            <li>Interfere with or disrupt the Services or servers or networks connected to the Services</li>
            <li>Share content that is harmful, threatening, abusive, harassing, defamatory, vulgar, or otherwise objectionable</li>
            <li>Impersonate any person or entity or falsely state or misrepresent your affiliation with a person or entity</li>
          </ul>
        </section>
        
        <section className="terms-section">
          <h3>6. Limitation of Liability</h3>
          <p>
            KNOW and its affiliates shall not be liable for any indirect, incidental, special, consequential, or punitive damages resulting from your access to or use of, or inability to access or use, the Services.
          </p>
        </section>
        
        <section className="terms-section">
          <h3>7. Changes to Terms</h3>
          <p>
            We reserve the right to modify these Terms of Service at any time. We will provide notice of significant changes by posting the new Terms on our website or through the Services. Your continued use of the Services after such modifications constitutes your acceptance of the revised Terms.
          </p>
        </section>
        
        <section className="terms-section">
          <h3>8. Contact Information</h3>
          <p>
            If you have any questions about these Terms, please contact us at:
          </p>
          <p>
            Emraay Solutions<br />
            150 King Street West<br />
            Toronto, ON M5H 1J9<br />
            Canada<br />
            Email: contact@emraay.com
          </p>
        </section>
        
        <div className="terms-footer">
          <p>Last Updated: May 08, 2023</p>
        </div>
      </div>
    </Modal>
  );
};

export default TermsOfService;